<template>
  <modal>
    <div>
      <div class="modal-content">
        <div class="mb-2">
          <img src="@/assets/images/introduction.png" class="w-full">
        </div>
        <div class="message mb-2 text-center">
          以下のリンクより「利用規約」をお読みになり、ご利用ください。
        </div>
        <div class="message mb-2 text-center">
          <a class="break-all text-link" @click="openTerms">
           「旅行プランニングサービス」の利用規約
          </a>
        </div>
      </div>
      <div class="modal-content">
        <div class="message mb-2 text-center">
          <a v-on:click="onTerms">
            <img :src=getIcon() class="w-6 inline" />
            <span>利用規約に同意する</span>
          </a>
        </div>
      </div>
      <div class="modal-button">
        <a class="button-primary block" @click="apply" v-bind:class="{ 'text-gray-700': !terms }">
          規約に同意して利用を開始する
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  components: {
    Modal
  },
  data () {
    return {
      terms: false
    }
  },
  methods: {
    getIcon: function () {
      if (this.terms) {
        return require('@/assets/images/check_box-24px.svg')
      } else {
        return require('@/assets/images/check_box_outline_blank-24px.svg')
      }
    },
    onTerms: function () {
      this.terms = !this.terms
    },
    openTerms: function () {
      window.open("https://tour.jre-maas.com/docs/hawaii/terms.htm")
    },
    apply: function () {
      if (this.terms) {
        this.$emit('closePlanTerms')
      }
    }
  }
}
</script>
